export default __webpack_public_path__ + "static/media/DreamStream_Icon.706fb14a.svg";